exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout-breadcrumb{font-size:15px}.layout-breadcrumb :deep(.ivu-breadcrumb-item-link){text-transform:capitalize}", ""]);

// exports
